// src/pages/Tickets/TicketCard.jsx
import React from "react";
import { Grid, Typography, Card, Chip, Box } from "@mui/material";
import moment from "moment";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";

const getStatusColorHex = (status) => {
  switch (status) {
    case "Open":
      return "#0288d1"; // info main
    case "In Progress":
      return "#ed6c02"; // warning main
    case "Closed":
      return "#d32f2f"; // error main (bright red)
    default:
      return "#bdbdbd"; // grey as default
  }
};

const getStatusColor = (status) => {
  switch (status) {
    case "Open":
      return "info";
    case "In Progress":
      return "warning";
    case "Closed":
      return "error"; // or change this if needed
    default:
      return "default";
  }
};

const TicketCard = ({ ticket, meData, usersData = [], districtData = [] }) => {
  const navigate = useNavigate();
  const handleCardClick = () => {
    navigate(`/tickets-edit/${ticket.id}`, { state: ticket });
  };
  const isAdmin = meData?.role_id !== 3;
  console.log(usersData, districtData);

  const createdUser = usersData.find((user) => user.value === ticket.created_user);
  const createdDistrict = districtData.find((dist) => dist.value === ticket.created_user_district);

  const createdUserName = createdUser?.title || `User ID: ${ticket.created_user}`;
  const createdDistrictName =
    createdDistrict?.title || `District ID: ${ticket.created_user_district}`;

  const truncateText = (text, limit = 60) =>
    text.length > limit ? `${text.slice(0, limit)}...` : text;

  return (
    <Card
      onClick={handleCardClick}
      sx={{
        p: 3,
        minHeight: "100%",
        borderRadius: 2,
        backgroundColor: "#f9f9f9",
        border: "1px solid #ae7cd663",
        // borderLeft: "6px solid #1976d2",
        borderLeft: `6px solid ${getStatusColorHex(ticket.status)}`,
        // borderBottom: "2px solid #3f1d62",
        boxShadow: "0px 1px 10px 5px rgba(63, 29, 98, 0.05)",
        // marginTop: "5px",
        // marginBottom: "5px",
        transition: "transform 0.5s ease",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        "&:hover": {
          transform: "scale(1.03)",
          cursor: "pointer",
        },
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle2" fontWeight="bold" sx={{ color: "black", mb: 1 }}>
          #Ticket ID - {ticket.id}
          {""}
          {ticket.prioritization && (
            <Box component="span" sx={{ ml: 1, fontWeight: "medium", fontSize: "0.85rem" }}>
              ({ticket.prioritization})
            </Box>
          )}
        </Typography>
        <Chip
          label={ticket.status}
          color={getStatusColor(ticket.status)}
          size="small"
          sx={{ fontWeight: 500 }}
        />
      </Box>

      {isAdmin && (
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
          <Typography variant="h6" fontWeight="bold">
            {createdUserName}
          </Typography>
          <Typography variant="h6" fontWeight="bold">
            {createdDistrictName}
          </Typography>
        </Box>
      )}

      {isAdmin ? (
  <Tooltip title={ticket.ticket_subject}>
    <Typography
      variant="subtitle2" // smaller than h6
      fontWeight="bold"
      sx={{
        color: "black", // black color for admin
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {truncateText(ticket.ticket_subject, 60)}
    </Typography>
  </Tooltip>
) : (
  <>
    <Tooltip title={ticket.ticket_subject}>
      <Typography
        variant="h6"
        fontWeight="bold"
        sx={{
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {truncateText(ticket.ticket_subject, 60)}
      </Typography>
    </Tooltip>

    {ticket.ticket_description && (
      <Tooltip title={ticket.ticket_description}>
        <Typography
          variant="body2"
          fontWeight="bold"
          sx={{
            color: "text.secondary",
            maxWidth: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {truncateText(ticket.ticket_description, 80)}
        </Typography>
      </Tooltip>
    )}
  </>
)}

      <hr
        style={{
          flexShrink: 0,
          borderTop: "0px solid rgba(0, 0, 0, 0.12)",
          borderRight: "0px solid rgba(0, 0, 0, 0.12)",
          borderLeft: "0px solid rgba(0, 0, 0, 0.12)",
          backgroundColor: "transparent",
          height: "0.07rem",
          margin: "1rem 0px",
          borderBottom: "none",
          opacity: 0.5,
          backgroundImage:
            "linear-gradient(to right, rgba(52, 71, 103, 0), rgb(0 59 128), rgba(52, 71, 103, 0))",
        }}
      />

      <Box mt={2} display="flex" justifyContent="space-between">
        <Typography variant="caption">
          Ticket Created : {moment(ticket.created_at).format("MMM DD, YYYY")}
        </Typography>
      </Box>
    </Card>
  );
};

TicketCard.propTypes = {
  ticket: PropTypes.shape({
    id: PropTypes.number.isRequired,
    created_user: PropTypes.number.isRequired,
    created_user_district: PropTypes.number.isRequired,
    ticket_subject: PropTypes.string.isRequired,
    ticket_description: PropTypes.string.isRequired,
    prioritization: PropTypes.string.isRequired,
    ticket_attachment: PropTypes.string,
    created_at: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
  meData: PropTypes.shape({
    role_id: PropTypes.number.isRequired,
  }).isRequired,
  usersData: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
    })
  ),
  districtData: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
    })
  ),
};

export default TicketCard;
